import './style.css'
import BackHandOutlinedIcon from '@mui/icons-material/BackHandOutlined';
import AdsClickOutlinedIcon from '@mui/icons-material/AdsClickOutlined';
import {Editor} from "@tldraw/editor";
import {useEffect, useState} from "react";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import {Tooltip} from "@mui/material";

export default function ToolBar(props: {editor?: Editor, controlHistory: (id: number)=> void, loading: boolean}) {
    const {editor, controlHistory, loading} = props
    const [activeToolId, setActiveToolId] = useState<string>('select');

    useEffect(() => {
        if (loading) {
            setActiveToolId('hand')
            editor?.setCurrentTool('hand')
        }else {
            setActiveToolId('select')
            editor?.setCurrentTool('select')
        }
    }, [loading, editor]);


    return <div className='toolBarContain'>
        <div style={{
            cursor: loading? 'not-allowed' : 'default',
            backgroundColor: activeToolId === 'select' ? 'var(--c-accent)' : '',
            color: activeToolId === 'select' ? 'var(--c-on-color)' : '',
        }} onClick={() => {
            if (loading) return
            setActiveToolId('select')
            editor?.setCurrentTool('select')
        }}>
            <Tooltip title={loading ? "当前有任务正在执行" : ''} placement="top">
                <AdsClickOutlinedIcon style={{fontSize: 22}}/>
            </Tooltip>
        </div>
        <div style={{
            backgroundColor: activeToolId === 'hand' ? 'var(--c-accent)' : '',
            color: activeToolId === 'hand' ? 'var(--c-on-color)' : '',
        }} onClick={() => {
            setActiveToolId('hand')
            editor?.setCurrentTool('hand')
        }}>
            <BackHandOutlinedIcon style={{fontSize: 22}}/>
        </div>
{/*        <div style={{
            backgroundColor: activeToolId === 'history' ? 'var(--c-accent)' : '',
            color: activeToolId === 'history' ? 'var(--c-on-color)' : '',
        }} onClick={() => {
            setActiveToolId('history')
            controlHistory(1)
        }}>
            <ContentPasteSearchIcon style={{fontSize: 22}}/>
        </div>*/}
    </div>;
}